<template>
    <rkm-modal
        extra-large
        ref="RkmModal"
        :title="`Serviço - ${item && item.unidadeNomeFantasia}`"
    >
        <rkm-form ref="RkmForm">
            <rkm-row>
                <rkm-col>
                    <rkm-form-select
                        :options="data.form.servicos"
                        :validations="validations.servico"
                        label="Serviço"
                        show-default-option
                        text-field="nome"
                        v-model="model.servicoId"
                        value-field="id"
                    />
                </rkm-col>

                <rkm-col cols="auto">
                    <rkm-button
                        :label="false"
                        @click="include"
                        color="primary"
                    >
                        Incluir
                    </rkm-button>

                    <rkm-button
                        :label="false"
                        @click="clean"
                    >
                        Limpar
                    </rkm-button>
                </rkm-col>
            </rkm-row>

            <rkm-table
                :fields="fields"
                :items="model.servicos"
            >
                <template v-slot:cell(actions)="{index}">
                    <rkm-button
                        @click="destroy(index)"
                        color="danger"
                        small
                        title="Excluir"
                    >
                        <rkm-icon icon="trash" />
                    </rkm-button>
                </template>
            </rkm-table>
        </rkm-form>

        <template v-slot:footer="{cancel}">
            <rkm-button @click="cancel">
                Cancelar
            </rkm-button>

            <rkm-button
                @click="save"
                color="primary"
            >
                Salvar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Mixins.
import {error, object, repository, stringCase} from '@/mixins'

// Vuex.
import {mapActions} from 'vuex'

export default {
    computed: {
        validations() {
            return {
                servico: {required: true},
            }
        },
    },
    created() {
        this.repositories = {
            parametrizacao: this.getConectaSusRepository('ambulatorio.parametrizacao'),
        }
    },
    data: () => ({
        fields: [
            {key: 'nome', label: 'Nome', sortable: true},
            {key: 'actions', label: 'Ações', class: 'col-min text-center'},
        ],
        item: null,
        model: {
            servicoId: null,
            servicos: [],
        },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(item) {
            this.reset()

            this.item = item

            this.model.servicos = this.clone(item.servicos)

            this.$refs.RkmModal.show()

            this.getServicos()
        },
        include() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    if (this.model.servicos && this.model.servicos.find(servico => servico.id === this.model.servicoId)) {
                        this.showValidationNotification('O serviço já foi incluído.')
                        return
                    }

                    const servico = this.data.form.servicos.find(servico => servico.id === this.model.servicoId)

                    this.model.servicos.push({
                        id: servico.id,
                        nome: servico.nome,
                    })

                    this.reset()
                })
        },
        destroy(index) {
            this.showDeleteConfirmation('Deseja realmente excluir o serviço?', async () => {
                this.model.servicos.splice(index, 1)
            })
        },
        save() {
            this.item.servicos = this.model.servicos

            this.$refs.RkmModal.hide()
        },
        clean() {
            this.reset()
        },
        reset() {
            this.model.servicoId = null
            this.model.unidadeNomeFantasia = null

            this.$nextTick().then(() => this.$refs.RkmForm.resetValidator())
        },
        getServicos() {
            const request = {
                origem: 'infraestrutura',
                listar: 'servicos',
            }

            this.setLoading()

            this.repositories.parametrizacao.list(request)
                .then(response => {
                    this.data.form.servicos = Object.assign(response.data)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
    },
    mixins: [error, object, repository, stringCase],
    props: {
        data: {type: Object, required: true},
    },
}
</script>